var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.39935 9.39886C6.7313 9.06692 7.26949 9.06692 7.60143 9.39886L12.0004 13.7978L16.3994 9.39886C16.7313 9.06692 17.2695 9.06692 17.6014 9.39886C17.9334 9.73081 17.9334 10.269 17.6014 10.6009L12.6014 15.6009C12.2695 15.9329 11.7313 15.9329 11.3993 15.6009L6.39935 10.6009C6.0674 10.269 6.0674 9.73081 6.39935 9.39886Z",
    fill: "#222222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.9b7c5aa1a00a028fb953f32709c02a12.svg";
export { ForwardRef as ReactComponent };